import React from "react";
import { Check, HelpCircle } from "lucide-react";

interface PostFixActionsProps {
  onFixed: () => void;
  onNeedHelp?: () => void;
  cmsGuide?: boolean;
}

const PostFixActions: React.FC<PostFixActionsProps> = ({ onFixed, onNeedHelp, cmsGuide }) => (
  <div className="ml-[34px] mt-3">
    <p className="mb-2 text-xs text-og01-text-secondary">
      {cmsGuide ? "Ready to mark this complete?" : "What would you like to do next?"}
    </p>
    <div className="flex flex-wrap gap-2.5">
      <button
        type="button"
        onClick={onFixed}
        className="flex flex-1 items-center justify-center gap-1.5 rounded-[11px] px-3 py-2.5 text-[13px] font-semibold transition-all hover:brightness-110"
        style={{
          background: "color-mix(in srgb, #22C55E 14%, transparent)",
          border: "1px solid color-mix(in srgb, #22C55E 30%, transparent)",
          color: "#22C55E",
        }}
      >
        <Check className="h-[15px] w-[15px]" />
        {cmsGuide ? "Got it, I've Fixed This" : "I've Fixed This"}
      </button>
      {!cmsGuide && onNeedHelp && (
        <button
          type="button"
          onClick={onNeedHelp}
          className="flex flex-1 items-center justify-center gap-1.5 rounded-[11px] border border-white/[0.07] bg-[#0F0F18] px-3 py-2.5 text-[13px] font-medium text-og01-text-secondary transition-colors hover:border-white/[0.12]"
        >
          <HelpCircle className="h-[15px] w-[15px]" />
          How do I implement this?
        </button>
      )}
    </div>
  </div>
);

export default PostFixActions;
